import * as React from 'react'
import { Bell, MessageCircle, Tv, UserCheck, Watch } from 'react-feather'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { MOBILE_APP as PRE } from 'main/util/i18n/namespaces'
import {
  Benefit,
  BenefitIconContainer,
  Container,
  Content,
  ContentContainer,
  Image,
  ImageContainer,
} from './Benefits.styles'

import { palette, spacing } from 'main/ui'
import { Text, Title } from 'main/ui/typography'

interface IBenefit {
  header: string
  icon: React.ReactElement
  paragraph: string
}

export default function Benefits() {
  const { t } = useTranslation(NAMESPACE)

  const benefits: IBenefit[] = [
    {
      header: t(`${PRE}-POST-UPDATES-BENEFIT`),
      icon: <Bell />,
      paragraph: t(`${PRE}-POST-UPDATES-BENEFIT-DESCRIPTION`),
    },
    {
      header: t(`${PRE}-TRACK-ACTIVITIES-BENEFIT`),
      icon: <Watch />,
      paragraph: t(`${PRE}-TRACK-ACTIVITIES-BENEFIT-DESCRIPTION`),
    },
    {
      header: t(`${PRE}-MAKE-ANNOUNCEMENTS-BENEFIT`),
      icon: <Tv />,
      paragraph: t(`${PRE}-MAKE-ANNOUNCEMENTS-BENEFIT-DESCRIPTION`),
    },
    {
      header: t(`${PRE}-SEND-MESSAGES-BENEFIT`),
      icon: <MessageCircle />,
      paragraph: t(`${PRE}-SEND-MESSAGES-BENEFIT-DESCRIPTION`),
    },
    {
      header: t(`${PRE}-VIEW-STUDENT-PROFILES-BENEFIT`),
      icon: <UserCheck />,
      paragraph: t(`${PRE}-VIEW-STUDENT-PROFILES-BENEFIT-DESCRIPTION`),
    },
  ]

  return (
    <Container>
      <ContentContainer>
        <Title
          kind="large"
          css={{ paddingBottom: `${spacing.majorScale(8)}px`, textAlign: 'center' }}
        >
          {t(`${PRE}-WITH-THE-WONDERSCHOOL-APP-YOU-CAN`)}
        </Title>
        <Content>
          <div>{benefits.map(renderBenefits)}</div>
          <ImageContainer>
            <Image src="https://ucarecdn.com/3c23f43e-0f8b-4af3-b453-884ede2c560e/iPhoneXrtilted2x.png" />
          </ImageContainer>
        </Content>
      </ContentContainer>
    </Container>
  )
}

const renderBenefits = (benefit: IBenefit) => (
  <Benefit key={benefit.header}>
    <BenefitIconContainer>
      <benefit.icon.type color={palette.slate} />
    </BenefitIconContainer>
    <div>
      <Title kind="section" css={{ color: palette.poppy }}>
        {benefit.header}
      </Title>
      <Text css={{ color: palette.slate }}>{benefit.paragraph}</Text>
    </div>
  </Benefit>
)
